module.exports = __webpack_public_path__ + "img/postfinance-efinance.faa37792.svg";